import { azAppreciateScreeningQuestions } from "./AZAppreciateScreener";

/**
 * Flow B variant of AZ Appreciate screener
 * Reorders questions to put CKD diagnosis question first
 */
export const azAppreciateFlowBScreeningQuestions = [
  azAppreciateScreeningQuestions[2], // chronic_kidney_disease → moved to question 1
  azAppreciateScreeningQuestions[0], // age → moved to question 2
  azAppreciateScreeningQuestions[1], // race_ethnicity → moved to question 3
  ...azAppreciateScreeningQuestions.slice(3), // rest unchanged
];
